import './yzj/index.less';
import './yzj/index';




// WEBPACK FOOTER //
// ./src/yzj.js